export default "__VITE_ASSET__01f04807__"